export default __webpack_public_path__ + "2686284478ab5c7c5c176cfcc3b2e68e.png";